export default __webpack_public_path__ + "static/media/doctor-5.87977116.jpg";